import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-setup-modal',
  templateUrl: './setup-modal.component.html',
  styleUrls: ['./setup-modal.component.scss']
})
export class SetupModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  countries = null
  branches = null
  data = null
  Success = null

  stateForm = new FormGroup({
    number_mode: new FormControl('', Validators.required),
    fin_yr: new FormControl('', Validators.required),
    branch_code: new FormControl('', Validators.required),
    bill_no: new FormControl('', Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      number_mode,
      fin_yr,
      branch_code,
      bill_no,
    } = this.stateForm.value;
    this.auth
      .postSetUp(
        number_mode,
        fin_yr,
        branch_code,
        bill_no,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth
      .getcountry()
      .subscribe(
        (resSuccess) => {

          this.countries = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );

      this.auth
      .getBranches()
      .subscribe(
        (resSuccess) => {

          this.branches = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }
  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      number_mode: title.number_mode,
      fin_yr: title.fin_yr,
      branch_code: title.branch_code,
      bill_no: title.bill_no,
    });
    console.log(this.stateForm.value)
  }

  view(branch) {
    this.mode = "view"
    this.isLoading = true;
    const code = branch.Branch_Code;
    this.auth
      .getSetUp(code)
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }


}
